import { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Secila instancë e Reveal krijon ScrollTrigger-in e vet kur montohet.
 *
 * Kjo është me qëllim: një ScrollTrigger i vetëm i krijuar një herë në nivel
 * faqeje nuk i sheh kurrë elementet që montohen më vonë dhe ato mbeten
 * përgjithmonë në opacity 0. Duke e lidhur trigger-in me vetë komponentin,
 * çdo element e regjistron veten sapo ekziston.
 */
export default function Reveal({
  children,
  delay = 0,
  y = 28,
  duration = 0.9,
  as: Tag = "div",
  className,
  style,
}) {
  const ref = useRef(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      gsap.set(el, { opacity: 1, y: 0 });
      return;
    }

    const ctx = gsap.context(() => {
      gsap.fromTo(
        el,
        { opacity: 0, y },
        {
          opacity: 1,
          y: 0,
          duration,
          delay,
          ease: "power3.out",
          scrollTrigger: {
            trigger: el,
            start: "top 88%",
            once: true,
          },
        }
      );
    }, el);

    // Elementet që mungonin kur u llogaritën pozicionet e para.
    ScrollTrigger.refresh();

    return () => ctx.revert();
  }, [delay, y, duration]);

  return (
    <Tag ref={ref} className={className} style={{ opacity: 0, ...style }}>
      {children}
    </Tag>
  );
}
